<template>
  <div>
    <v-card>
      <v-row class="d-flex pa-6">
        <v-col cols="6">
          <site-group-filter
            store="audience"
            :initialValue="[42]"
            class="ml-8"
          />
        </v-col>
        <v-col cols="6">
          <v-expansion-panels class="mb-2" id="expandableFilters">
            <v-expansion-panel>
              <v-expansion-panel-header>
                Déplier pour filtrer sur les sites</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <site-filter store="audience" class="ml-4 mr-8" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col cols="4">
          <v-select
            class="ml-8"
            outlined
            v-model="gscSourceType"
            :items="gscSourceTypeList"
            :menu-props="{ maxHeight: '400', zIndex: 13 }"
            label="Pour la source "
            item-text="name"
            item-value="id"
          >
          </v-select>
        </v-col>
        <v-col cols="4">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                label="Sélectionnez une période"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
              ></v-text-field>
            </template>

            <v-date-picker
              v-model="selectedRange"
              type="month"
              :range="true"
              @change="updateTextField"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="4" class="d-flex">
          <v-spacer />
          <apply-filters
            :disabled="isDisabled"
            outlined
            color="secondary"
            class="mr-8"
        /></v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import useAxios from "@/hooks/useAxios";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import SiteFilter from "@/components/common/filters/SiteFilter";
import SiteGroupFilter from "@/components/common/filters/SiteGroupFilter";

export default {
  name: "GscMonthlyFilter",
  components: {
    ApplyFilters,
    SiteFilter,
    SiteGroupFilter,
  },
  data() {
    return {
      menu: false,
      dateRangeText: "",
      gscSourceTypeList: [],
    };
  },

  setup() {
    const { isLoading, axiosGet } = useAxios();

    return {
      isLoading,
      axiosGet,
    };
  },
  async created() {
    await this.getSourceTypeList();
    if (!this.selectedRange || this.selectedRange.length !== 2) {
      const now = new Date();
      const start = `${now.getFullYear()}-01`;
      const end = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
        2,
        "0"
      )}`;
      this.selectedRange = [start, end]; // déclenche le setter et update store
    }

    this.updateTextField(this.selectedRange);
  },

  methods: {
    updateTextField(value) {
      if (value && value.length === 2) {
        let [start, end] = value;

        if (new Date(start) > new Date(end)) {
          [start, end] = [end, start];
        }

        this.selectedRange = [start, end];

        const format = (date) =>
          new Date(date).toLocaleDateString("fr-FR", {
            year: "numeric",
            month: "2-digit",
          });

        this.dateRangeText = `${format(start)} - ${format(end)}`;
        this.menu = false;
      }
    },

    async getSourceTypeList() {
      const res = await this.axiosGet("/gsc_source");
      this.gscSourceTypeList = res.data;
      if (res.data.length > 0) {
        this.gscSourceType = res.data[0].id;
      }
    },
  },

  computed: {
    getSites() {
      return this.$store.getters["audience/getSites"];
    },
    isDisabled() {
      return this.isLoading || this.getSites.length === 0;
    },
    selectedRange: {
      get() {
        return this.$store.getters["audience/getSelectedGscDateRange"];
      },
      set(value) {
        this.$store.dispatch("audience/updateSelectedGscDateRange", value);
      },
    },
    gscSourceType: {
      get() {
        return this.$store.getters["audience/getGscSourceType"];
      },
      set(value) {
        this.$store.dispatch("audience/updateGscSourceType", value);
      },
    },
  },
};
</script>

<style></style>
